import * as React from 'react';
import _ from 'lodash';
import { VIEWER_MODE } from './store/enums';
import { Box, CircularProgress, Stack } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useSelector, useDispatch } from 'react-redux';
import { documentViewerConfig } from './assets/documentViewerConfig';
import {
    setLoading,
    setViewerMode,
    setAllDocuments,
    setAttendances,
    storeOpenTabs,
    viewerMode,
    activeViewerWindow,
    panelFilter,
} from './store/documentViewerReducer';
import { DocumentViewTimeline } from './documentViewTimeline';
import { DocumentView } from './documentView';
//import { ResizableBox } from 'react-resizable';
import { documentViewerPalette } from './assets/palette';
import APIDocuments from './apiDocuments';
import { DocumentListView } from './documentListView';
import { unstable_createMuiStrictModeTheme as createMuiTheme } from '@mui/material/styles';
import mocks from '../../store/researchPatient';
import { FilterDocuments } from './filterDocuments';

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100%',
        display: 'flex',
        '& .box': {
            overflow: 'hidden',
            position: 'relative',
            height: '100%',
        },
        '& .custom-handle': {
            position: 'absolute',
            width: '1px',
            height: '100%',
            backgroundColor: theme.palette.documentViewer.timelineBorderColor,
            opacity: '0.9',
            borderRadius: '0',
            transition: 'all 0.2s ease',
        },
        '& .custom-handle-e': {
            top: '0',
            right: '0px',
            cursor: 'ew-resize',
            '&.resizable-off': {
                cursor: 'default',
            },
        },
    },
    loader: {
        width: '100%',
        height: '100%',
        alignItems: 'center',
        textAlign: 'center',
        paddingTop: 'calc(50vh - 110px)',
    },
    documentsTimeline: {
        width: '200px',
    },
    documentsList: {
        width: '100%',
    },
    documents: {
        width: 'calc(100% - 200px)',
    },
    timeline: {
        minWidth: '300px',
        maxWidth: '300px',
        height: '100%',
        maxHeight: '100%',
        borderRightStyle: 'solid',
        borderRightWidth: '1px',
        overflowY: 'auto',
        paddingRight: '2px',
    },
}));

export function Viewer(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const viewerRef = React.useRef();
    const viewMode = useSelector(viewerMode);
    const panelVisible = useSelector(panelFilter);
    const activeWindowIdx = useSelector(activeViewerWindow);
    const loadingMain = useSelector((state) => _.get(state, 'documentViewer.loading.main', false));

    //THAT IS FOR RESIZABLE BOX, BUT WE HAVE CUSTOM RESIZABLE BOX NOW
    // const [width, setWidth] = React.useState(360);
    // const [height, setHeight] = React.useState(0);
    const [ready, setReady] = React.useState(false);
    const loadingDocs = useSelector((state) => _.get(state, 'documentViewer.loading.docsuments', false));
    const [colorOfBackground, setColorOfBackground] = React.useState('transparent');
    const [openTabs, setOpenTabs] = React.useState([]);
    const [openTabIds, setOpenTabIds] = React.useState([]);
    const [selectedTabIds, setSelectedTabIds] = React.useState(new Array(4)); //can be many windows with opened tab

    const selectTab = (tab) => {
        if (props.catalogId !== '') {
            setOpenTabs((prev) => {
                let ot = _.cloneDeep(prev);
                if (_.findIndex(prev, (openTab) => openTab.tabId === tab.tabId) === -1) {
                    ot.push(tab);
                    setOpenTabIds(ot.map((t) => t.tabId));
                }
                setSelectedTabIds((prev) => {
                    let sti = _.cloneDeep(prev);
                    sti[activeWindowIdx] = tab.tabId;
                    return sti;
                });
                return ot;
            });
        }
    };

    const changeActiveTabId = (tabId) => {
        setSelectedTabIds((prev) => {
            let sti = _.cloneDeep(prev);
            sti[activeWindowIdx] = tabId;
            return sti;
        });
    };

    const closeTab = (tabId) => {
        const selectedWindowIdx = _.findIndex(selectedTabIds, (selectedTab) => selectedTab === tabId);
        if (selectedWindowIdx !== -1) {
            let sti = _.cloneDeep(selectedTabIds);
            sti[selectedWindowIdx] = undefined;
            setSelectedTabIds(sti);
        }
        setOpenTabs((prev) => {
            let ot = _.cloneDeep(prev);
            const oTIdx = _.findIndex(ot, (openTab) => openTab.tabId === tabId);
            ot.splice(oTIdx, 1);
            setOpenTabIds(ot.map((t) => t.tabId));
            return ot;
        });
    };

    React.useEffect(() => {
        dispatch(storeOpenTabs(openTabs));
    }, [openTabs]);

    React.useEffect(() => {
        const themesN = ['dark', 'light'];
        _.forEach(themesN, (theme) => {
            let tmpObj = window._getThemeObject(theme);
            Object.assign(tmpObj.palette, { documentViewer: _.get(documentViewerPalette, theme) });
            _.set(window, `_themes.${theme}`, createMuiTheme(tmpObj));
        });
        window._setTheme(window._getTheme());

        setColorOfBackground(_.get(documentViewerPalette, `${window._getTheme()}.timelineBorderColor`, 'transparent'));

        if (_.get(window.envConfig, 'documentViewer', null) == null) {
            window.envConfig.documentViewer = documentViewerConfig;
        }
        setTimeout(() => {
            dispatch(setViewerMode({ mode: VIEWER_MODE.DOC_VIEW })); //OR SOME DEFAULT
            setTimeout(() => {
                setReady(true);
            }, 1);
        }, 1);

        //THAT IS FOR RESIZABLE BOX, BUT WE HAVE CUSTOM RESIZABLE BOX NOW
        // function updateSize() {
        //     setHeight(_.get(viewerRef, 'current.clientHeight', 1))
        // }
        // window.addEventListener('resize', updateSize);
        // updateSize();
        // setTimeout(() => {
        //     dispatch(setViewerMode({ mode: VIEWER_MODE.DOC_VIEW })); //OR SOME DEFAULT
        //     setTimeout(() => {
        //         setReady(true);
        //     }, 1);
        // }, 1);
        return () => {
            // window.removeEventListener('resize', updateSize);
        };
    }, []);

    React.useEffect(() => {
        dispatch(setLoading({ loadingPart: 'documents', loading: true }));
        if (props.catalogId) {
            // API.getPatientAttendancesHistory(props.catalogId).then((attendances) => {
            //     console.log('attendances', attendances);
            // });
            APIDocuments.getAllDocumentsByCatalogue(props.catalogId).then((docs) => {
                dispatch(setAllDocuments({ catalog: props.catalogId, docs: _.filter(docs, (d) => d.src == 'unity_store') }));
                dispatch(setAttendances({ catalog: props.catalogId, attendances: _.filter(docs, (d) => d.src == 'attendances') }));
                dispatch(setLoading({ loadingPart: 'documents', loading: false }));
            });
        } else {
            dispatch(setLoading({ loadingPart: 'documents', loading: false }));
            dispatch(setAllDocuments({ catalog: props.catalogId, docs: undefined }));
            dispatch(setAttendances({ catalog: props.catalogId, attendances: undefined }));
        }
    }, [props.catalogId]);

    return (
        <Box className={classes.root} ref={viewerRef}>
            {(loadingDocs || loadingMain) && (
                <Box className={classes.loader}>
                    <CircularProgress size={'6rem'} />
                </Box>
            )}
            {ready && !loadingDocs && viewMode === VIEWER_MODE.DOC_VIEW && (
                // <ResizableBox
                //     className="box"
                //     width={width}
                //     height={height}
                //     minConstraints={[width, Infinity]}
                //     maxConstraints={[width, Infinity]}
                //     handle={(h, ref) => <span className={`custom-handle custom-handle-${h} resizable-off`} ref={ref} />}
                //     resizeHandles={['e']}
                // >
                //
                // </ResizableBox>
                <Stack direction={'row'} gap={'0px'}>
                    <Box className={classes.timeline} sx={{ borderRightColor: colorOfBackground }}>
                        <DocumentViewTimeline openedTabIds={openTabIds} selectedTabs={selectedTabIds} selectTab={selectTab} />
                    </Box>
                    {panelVisible && (
                        <Box className={classes.timeline} sx={{ borderRightColor: colorOfBackground }}>
                            <FilterDocuments />
                        </Box>
                    )}
                </Stack>
            )}
            {ready && !loadingDocs && viewMode === VIEWER_MODE.DOC_VIEW && (
                <DocumentView openTabs={openTabs} selectedTabs={selectedTabIds} changeActiveTabId={changeActiveTabId} closetab={closeTab} />
            )}
            {ready && !loadingDocs && viewMode === VIEWER_MODE.LIST && <DocumentListView />}
        </Box>
    );
}
